import { Tabs } from '@snack-uikit/tabs';

import { DYNAMIC_CONTENT_CLASS_NAMES } from '@/constant/dynamic';
import { DATA_TEST_IDS_INJECTORS } from '@/constant/tests';
import { head } from '@/utils/common';

import { classNameIncludes, collectTextContent, findElements } from '../utils';
import s from './styles.module.scss';
import { makeInjector, nodeClassIs } from './utils';

const isTabHeadersClassName = classNameIncludes(DYNAMIC_CONTENT_CLASS_NAMES.tabHeader);
const isTabContentClassName = classNameIncludes(DYNAMIC_CONTENT_CLASS_NAMES.tabContent);

export const tabsInjector = makeInjector((node, children) => {
  const headersContent = collectTextContent(findElements(children, isTabHeadersClassName));
  const contents = findElements(children, isTabContentClassName);
  return (
    <div id={node.attribs.id} className={s.tabs_wrapper}>
      <Tabs defaultValue={head(headersContent)}>
        <Tabs.TabBar data-test-id={DATA_TEST_IDS_INJECTORS.tabs}>
          {headersContent.map(header => (
            <Tabs.Tab key={header} label={header} value={header} />
          ))}
        </Tabs.TabBar>
        {contents.map((content, ix) => {
          return (
            <Tabs.TabContent className={s.tab_content_wrapper} key={content.props.id || ix} value={headersContent[ix]}>
              {content.props.children}
            </Tabs.TabContent>
          );
        })}
      </Tabs>
    </div>
  );
}, nodeClassIs(DYNAMIC_CONTENT_CLASS_NAMES.tabs));
